import React from 'react';

const Troubleshooting = () => {
  const issues = [
    {
      icon: '❌',
      title: 'Minting Failed',
      cause: 'Insufficient gas, network issues, or label taken',
      solution: 'Check gas limit, ensure Mainnet, try different name'
    },
    {
      icon: '🔗',
      title: 'Domain Not Showing',
      cause: 'ENS cache delay or wrong network',
      solution: 'Wait 2-5 minutes, ensure Mainnet connection'
    },
    {
      icon: '💰',
      title: 'Zwallet Connection',
      cause: 'Wallet not unlocked or wrong network',
      solution: 'Unlock Zwallet, ensure Ethereum Mainnet'
    },
    {
      icon: '🔒',
      title: 'Password Issues',
      cause: 'Wrong password or corrupted data',
      solution: 'Use seed phrase to restore wallet'
    },
    {
      icon: '🔄',
      title: 'Transaction Pending',
      cause: 'Network congestion or low gas',
      solution: 'Wait or speed up transaction'
    },
    {
      icon: '📱',
      title: 'Session Expired',
      cause: '30-minute inactivity timeout',
      solution: 'Re-enter password to unlock'
    }
  ];

  return (
    <div className="help-section">
      <div className="section-header">
        <div className="icon">🐛</div>
        <h2>Troubleshooting Guide</h2>
      </div>
      
      <div className="section-grid">
        {issues.map((issue, index) => (
          <div key={index} className="info-card">
            <h3><span style={{ marginRight: '10px' }}>{issue.icon}</span>{issue.title}</h3>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '10px' }}>
              <strong style={{ color: 'var(--gold)' }}>Cause:</strong> {issue.cause}
            </p>
            <p style={{ color: 'var(--text-secondary)', margin: 0 }}>
              <strong style={{ color: 'var(--gold)' }}>Solution:</strong> {issue.solution}
            </p>
          </div>
        ))}
      </div>
      
      <div className="warning-box">
        <h4><span>🆘</span> Still Need Help?</h4>
        <p style={{ color: 'var(--text-light)', margin: 0 }}>
          If you continue to experience issues, visit <a href="https://zpost.ai" style={{ color: 'var(--gold)' }}>zpost.ai</a> 
          or join the .zpost.eth community for support.
        </p>
      </div>
    </div>
  );
};

export default Troubleshooting;
